import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { filter, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Firmenverwaltung';

  constructor(
    public router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) { }

  login() {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        switchMap(() => {
          if (this.msalService.instance.getAllAccounts().length > 0) {
            return of(true)
          }
          return of(false)
        })
      )
      .subscribe(() => {
        this.msalService.loginRedirect();
      })
  }

  logout() {
    this.msalService.logoutRedirect();
  }
}
